import store from "@frameworks/web/redux/store";
import { USER_STATUS, USER_STATUS_ERROR_DATA, USER_STATUS_HIDE_ERROR_DATA, USER_STATUS_START_LOADER, USER_STATUS_STOP_LOADER, } from "../interface/IUserStatus";
class UserStatusActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getUserStatus(userStatus) {
        this.dispatch({
            type: USER_STATUS,
            payload: userStatus,
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: USER_STATUS_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: USER_STATUS_HIDE_ERROR_DATA,
        });
    }
    startLoader() {
        this.dispatch({
            type: USER_STATUS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: USER_STATUS_STOP_LOADER,
        });
    }
}
export default UserStatusActions;
